import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';
import TonePill, { type PillTone } from '@UI/Pages/Administration/AiCosts/Shared/TonePill';

const cellStyle = css`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 0.1875rem;
	font-family: ${theme.fonts.mono};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.ink};
`;

const detailStyle = css`
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.small};
	color: ${theme.colors.inkSecondary};
`;

type Props = {
	readonly label: string;
	/** Small line under the value: a duration, an average, what is excluded. */
	readonly detail?: string | null;
	/** A pill under the value: a missing price or a deviation. */
	readonly chip?: string | null;
	readonly chipTone?: PillTone;
	/** Ink of the amount; the audio and document columns are tinted. */
	readonly color?: string;
	readonly isBold?: boolean;
};

/** A right-aligned figure of a table, with its optional detail line and pill. */
const AmountCell: React.FC<Props> = ({
	label,
	detail = null,
	chip = null,
	chipTone = 'warning',
	color,
	isBold = false,
}) => {
	return (
		<span css={cellStyle}>
			<span style={{ color, fontWeight: isBold ? theme.fontWeights.bold : undefined }}>{label}</span>
			<ConditionalLoader data={detail}>
				{(text) => <span css={detailStyle}>{text}</span>}
			</ConditionalLoader>
			<ConditionalLoader data={chip}>
				{(text) => <TonePill text={text} tone={chipTone} />}
			</ConditionalLoader>
		</span>
	);
};

export default AmountCell;
